import React from 'react';
import { Box, Button, Skeleton, Text, Title } from '@nimbus-ds/components';
import { useIsMobile } from 'commons/hooks';

function EmptyStateFirstSectionSkeleton(): JSX.Element {
  const isMobile = useIsMobile();

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? 'column' : 'row'}
      gap="4"
      alignItems="center"
    >
      <Box flex="1" display="flex" justifyContent="flex-start">
        <Skeleton
          width={isMobile ? '200px' : '320px'}
          height={isMobile ? '200px' : '320px'}
        />
      </Box>
      <Box flex="2" display="flex" flexDirection="column" gap="none">
        <Text.Skeleton width="100%" />
        <Box marginTop="2" marginBottom="4">
          <Title.Skeleton width="100%" />
        </Box>
        <Text.Skeleton width="100%" />
        <Box display="flex" gap="4" marginTop="9">
          <Button.Skeleton />
          <Button.Skeleton />
        </Box>
      </Box>
    </Box>
  );
}

export default EmptyStateFirstSectionSkeleton;
